module.exports = __webpack_public_path__ + "static/hifi4-1680fce1c42380599da7a14605321c5d.jpg";